import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

function getUser() {
    const res = localStorage.getItem('user') || '{}';
    return JSON.parse(res);
}


export default new Vuex.Store({
    state: {
        token: localStorage.getItem('token') || '',
        refreshToken: localStorage.getItem('refreshToken') || '',
        user: getUser(),
    },
    mutations: {
        // refresh token
        UPDATE_TOKEN(state, token) {
            state.token = token
            localStorage.setItem('token', token)
        },
        // set tokens
        SET_TOKENS(state, { token, refreshToken }) {
            state.token = token
            state.refreshToken = refreshToken
            localStorage.setItem('token', token)
            localStorage.setItem('refreshToken', refreshToken)
        },
        // clear token
        CLEAR_TOKENS(state) {
            state.token = ''
            state.refreshToken = ''
            localStorage.removeItem('token')
            localStorage.removeItem('refreshToken')
        },
        CLEAR_CURRENT_USER(state) {
            state.user = '{}';
            localStorage.removeItem('user')
        },
        SET_CURRENT_USER(state, user) {
            state.user = user;
            localStorage.setItem('user', user);
        }
    },
    actions: {
        logout({ commit }) {
            commit('CLEAR_TOKENS')
            commit('CLEAR_CURRENT_USER')
            // 跳轉至登錄頁
            location.href = '/sign-in';
        }
    }
})